__turbopack_context__.v({
  "frame": "DitherBody-module__IvDdHW__frame",
  "rDot": "DitherBody-module__IvDdHW__rDot",
  "rDotBottom": "DitherBody-module__IvDdHW__rDotBottom",
  "rDotLeft": "DitherBody-module__IvDdHW__rDotLeft",
  "rDotRight": "DitherBody-module__IvDdHW__rDotRight",
  "rDotTop": "DitherBody-module__IvDdHW__rDotTop",
  "rFrame": "DitherBody-module__IvDdHW__rFrame",
  "rLabel": "DitherBody-module__IvDdHW__rLabel",
  "rValue": "DitherBody-module__IvDdHW__rValue",
  "readout": "DitherBody-module__IvDdHW__readout",
  "surface": "DitherBody-module__IvDdHW__surface",
});
